import styles from "@styles/HomeView.module.css"
import clsx from "clsx"
import { PersonalAssistantMessage } from "./personalAssistantMessage/PersonalAssistentMessage"
import { usePersonalAssistantMessageContext } from "@/app/context/PersonalAssistantMessageContext"
import { convertDateTimeToTimePassedString } from "@/app/helpers/utils/time"
import Date from "../home/Date"
import HomeTaskList from "./HomeTaskList"
import TabBar from "../common/tabbar/TabBar"

export default function Home() {
  const personalAssistantMessageContext = usePersonalAssistantMessageContext()

  const personalAssistantMessage =
    personalAssistantMessageContext?.personalAssistantMessage
  return (
    <div className={clsx(styles.pageFrame)} data-scroll-container>
      <div className={clsx(styles.main)}>
        {/* Header */}

        <div className={clsx(styles.header)}>
          <div className={clsx(styles.date)}>
            <Date />
          </div>
        </div>

        {/* Updated Time */}

        {personalAssistantMessage?.generatedAt && (
          <div className={clsx("callout", styles.latestUpdateTimeContainer)}>
            <div className={clsx(styles.latestUpdateTimeGreenDot)}>
              <div></div>
            </div>
            <span>
              {convertDateTimeToTimePassedString(
                personalAssistantMessage.generatedAt,
              )}
            </span>
          </div>
        )}

        {/* Personal Assistant Message */}

        <div className={clsx(styles.personalAssistantMessageContainer)}>
          <PersonalAssistantMessage />
        </div>

        {/* Important Tasks */}

        <HomeTaskList />
      </div>
      <TabBar />
    </div>
  )
}
